<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">
        {{ $t('studentInsurance.pageTitle') }}
      </h1>
      <ts-breadcrumb
        :items="[
          { text: $t('toHomePage'), href: '/' },
          {
            text: $t('studentInsurance.pageTitle'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <a-tabs :default-active-key="currentTab" v-model="currentTab">
          <a-tab-pane :key="1" :tab="$t('studentInsurance.insurance')">
            <InsuranceTable :branches="branches" v-if="currentTab === 1" />
          </a-tab-pane>
          <a-tab-pane
            :key="2"
            :tab="$t('studentInsurance.failed')"
            force-render
          >
            <failedInsurance :branches="branches" v-if="currentTab === 2" />
          </a-tab-pane>
        </a-tabs>
      </ts-card-wrapper>
    </ts-card>
  </div>
</template>

<script>
import InsuranceTable from './components/insurance-table.vue'
import failedInsurance from './components/failed-insurance.vue'
import { mapActions } from 'vuex'
export default {
  name: 'studentInsurance',
  components: {
    InsuranceTable,
    failedInsurance
  },
  data() {
    return {
      currentTab: 1,
      branches: []
    }
  },
  created() {
    this.fetchBranch()
  },
  methods: {
    ...mapActions('studentInsurance', ['formViewModel']),
    async fetchBranch() {
      const response = await this.formViewModel({
        fnName: 'assign_branch'
      })
      this.branches = response.assign_branch
    }
  }
}
</script>
